'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import PageHead from '@/app/customer-homepage/components/PageHead';
import Arrow from '@/app/customer-homepage/components/Arrow';

const NotFound = () => {
    const router = useRouter();

    const handleGoHome = () => {
        router?.push('/');
    };

    const handleGoBack = () => {
        if (typeof window !== 'undefined') {
            window.history?.back();
        }
    };

    return (
        <PageHead
            eyebrow="Error 404"
            title="Page not found."
            lede="The page you're looking for doesn't exist. Let's get you back."
        >
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <button
                    type="button"
                    onClick={handleGoHome}
                    className="btn-block btn-go"
                >
                    Back to home <Arrow />
                </button>

                <button
                    type="button"
                    onClick={handleGoBack}
                    className="btn-block btn-line"
                >
                    Go back
                </button>
            </div>
        </PageHead>
    );
};

NotFound.propTypes = {};

export default NotFound;
